import { Outlet } from "react-router-dom";

export function LoginLayout() {
  return (
    <div className="h-screen flex">
      <div className="w-full md:w-1/2 pt-8 flex flex-col items-center">
        <Outlet />
      </div>
      <img
        className="md:w-1/2 h-screen md:block hidden object-cover"
        src="https://swivl-cdn.s3-us-west-1.amazonaws.com/LoginScreenImage.png"
        alt="Hand holding a phone with Swivl app"
      />
    </div>
  );
}
